import { Component, Input } from '@angular/core';
import { IAttachment } from '@literax/models/http/attachment.model';

import { UntilDestroy } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-attachment-signature',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
})
export class AttachmentComponent {
  @Input() attachment: IAttachment;
  @Input() active: boolean;
  
}
